module.exports = __webpack_public_path__ + "img/columns-gap.7e724a46.svg";